import { initAirbrakeClient } from '@ui/lib/airbrake/client'

import { AIRBRAKE_PROJECT } from '@web-app/lib/airbrake'

initAirbrakeClient(AIRBRAKE_PROJECT)
